import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "lines" }
const _hoisted_2 = { class: "img-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "transition" }
const _hoisted_5 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
      return (_openBlock(), _createElementBlock("div", {
        key: line.nb,
        class: "line"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.videos, (video) => {
          return (_openBlock(), _createElementBlock("div", {
            key: video.id,
            class: "video"
          }, [
            _createVNode(_component_router_link, {
              class: "link",
              to: '/video/' + video.id,
              id: video.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: _ctx.videoImage(video)
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(video.name), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to", "id"])
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}